var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tarifas" },
    [
      _c(
        "v-form",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            width: "100%"
          },
          model: {
            value: _vm.isFormValid,
            callback: function($$v) {
              _vm.isFormValid = $$v
            },
            expression: "isFormValid"
          }
        },
        [
          _c(
            "fieldset",
            {
              staticStyle: {
                width: "100%",
                "margin-bottom": "20px",
                display: "flex",
                height: "95%",
                border: "1px solid rgb(220, 220, 220)"
              }
            },
            [
              _c(
                "legend",
                {
                  staticStyle: {
                    "margin-left": "0.3rem",
                    color: "#9e9e9e",
                    "font-size": "0.8rem"
                  }
                },
                [_vm._v("\n        Búsqueda\n      ")]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    width: "100%"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "20px", width: "50%" } },
                    [
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "vehiculoRequerido",
                          "error-messages": _vm.errors.collect(
                            "vehiculoRequerido"
                          ),
                          required: "",
                          label: "Vehículos",
                          items: _vm.vehiculos,
                          "item-text": "patente",
                          "item-value": "cod_vehiculo",
                          chips: "",
                          "deletable-chips": "",
                          dense: ""
                        },
                        model: {
                          value: _vm.vehiculosSeleccionados,
                          callback: function($$v) {
                            _vm.vehiculosSeleccionados = $$v
                          },
                          expression: "vehiculosSeleccionados"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { margin: "20px" } },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Fecha Inicio",
                              max: _vm.fechaMaxima
                            },
                            model: {
                              value: _vm.fechaDesde,
                              callback: function($$v) {
                                _vm.fechaDesde = $$v
                              },
                              expression: "fechaDesde"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Inicio" },
                            model: {
                              value: _vm.horaDesde,
                              callback: function($$v) {
                                _vm.horaDesde = $$v
                              },
                              expression: "horaDesde"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { margin: "20px" } },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Fecha Fin", max: _vm.fechaMaxima },
                            model: {
                              value: _vm.fechaHasta,
                              callback: function($$v) {
                                _vm.fechaHasta = $$v
                              },
                              expression: "fechaHasta"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Fin" },
                            model: {
                              value: _vm.horaHasta,
                              callback: function($$v) {
                                _vm.horaHasta = $$v
                              },
                              expression: "horaHasta"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "#FFE700" },
                                on: {
                                  click: function($event) {
                                    return _vm.buscaDashboard()
                                  }
                                }
                              },
                              [_vm._v("Buscar")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm.busqueda
        ? _c("div", [
            _c(
              "fieldset",
              {
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  display: "flex",
                  height: "95%",
                  border: "1px solid rgb(220, 220, 220)"
                }
              },
              [
                _c(
                  "legend",
                  {
                    staticStyle: {
                      "margin-left": "0.3rem",
                      color: "#9e9e9e",
                      "font-size": "0.8rem"
                    }
                  },
                  [_vm._v("\n        Conducción\n      ")]
                ),
                _c("v-card", { attrs: { id: "cards" } }, [
                  _c("table", [
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Primer encendido:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].primer_encendido
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Último apagado:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          _vm._s(_vm.data.reporte_conduccion[0].ultimo_apagado)
                        )
                      ])
                    ])
                  ])
                ]),
                _c("v-card", { attrs: { id: "cards" } }, [
                  _c("table", [
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Velocidad Máxima:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas
                                .velocidad_max
                            ) +
                            " Km/Hr\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Velocidad Media:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas
                                .velocidad_media
                            ) +
                            " Km/Hr\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("RPM Máximo:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas.rpm_max
                            ) +
                            " rpm\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Torque Medio:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas
                                .torque_medio
                            ) +
                            " %\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("% Tiempo Ralenti:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas
                                .tiempo_ralenti
                            ) +
                            " %\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("% RPM Zona Verde [1200-1600 rpm]:")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].maximas
                                .rpm_zona_verde
                            ) +
                            " %\n            "
                        )
                      ])
                    ])
                  ])
                ]),
                _c("v-card", { attrs: { id: "cards" } }, [
                  _c("table", [
                    _c("tr", { attrs: { id: "columna" } }, [
                      _c("th", [_vm._v("Alarmas:")]),
                      _c("th", [_vm._v("Cantidad")]),
                      _c("th", [_vm._v("Valor Máximo")])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("RPM Altas (E1)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_rpm
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_rpm
                            ) +
                            " rpm\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Velocidad (E2 y E3)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_velocidad
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_velocidad
                            ) +
                            "\n              Km/Hr\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Ralentí (E4)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_ralenti
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_ralenti
                            ) +
                            "\n              Hrs\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Veleo (E5)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_veleo
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_veleo
                            ) +
                            " Seg\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Aceleración brusca (E7)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_aceleracion
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_aceleracion
                            ) +
                            "\n              Km/Hr/Seg\n            "
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v("Frenada Brusca (E8)")
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .total_alarmas_frenada
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("th", { attrs: { id: "data" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.reporte_conduccion[0].alarmas
                                .valor_maximo_frenada
                            ) +
                            "\n              Km/Hr/Seg\n            "
                        )
                      ])
                    ])
                  ])
                ])
              ],
              1
            ),
            _c(
              "fieldset",
              {
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  display: "flex",
                  height: "95%",
                  border: "1px solid rgb(220, 220, 220)"
                }
              },
              [
                _c(
                  "legend",
                  {
                    staticStyle: {
                      "margin-left": "0.3rem",
                      color: "#9e9e9e",
                      "font-size": "0.8rem"
                    }
                  },
                  [_vm._v("\n        Actividad\n      ")]
                ),
                _c(
                  "v-card",
                  { attrs: { id: "cards" } },
                  [
                    _c("table", [
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } }, [
                          _vm._v("Recorrido (Km):")
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Odómetro inicial")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .odometro_inicial
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Odómetro final")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .odometro_final
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } })
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Operación")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .odometro_operacion
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [_vm._v("Marcha")]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .distancia_marcha
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Marcha con Crucero")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .distancia_en_crucero
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Marcha sin Crucero")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].recorrido
                                    .distancia_sin_crucero
                                )
                              ) +
                              "\n              Km\n            "
                          )
                        ])
                      ])
                    ]),
                    _c("doughnutComp", {
                      ref: "doughnutCompRefRecorrido",
                      attrs: { height: 280 }
                    })
                  ],
                  1
                ),
                _c(
                  "v-card",
                  { attrs: { id: "cards" } },
                  [
                    _c("table", [
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } }, [
                          _vm._v("Consumo (Lt):")
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Odólitro inicial")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .odolitro_inicial
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Odólitro final")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .odolitro_final
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } })
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Operación")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_operacion
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [_vm._v("Marcha")]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_marcha
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Marcha con Crucero")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_marcha_crucero
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Ralentí")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_ralenti
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Detenido no Ralentí")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_detenido_no_ralenti
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [_vm._v("PTO")]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].consumo
                                    .consumo_pto
                                )
                              ) +
                              "\n              Lt\n            "
                          )
                        ])
                      ])
                    ]),
                    _c("doughnutComp", {
                      ref: "doughnutCompRefConsumo",
                      attrs: { height: 280 }
                    })
                  ],
                  1
                ),
                _c(
                  "v-card",
                  { attrs: { id: "cards" } },
                  [
                    _c("table", [
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } }, [
                          _vm._v("Tiempo (Hr):")
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Horómetro inicial")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_inicial
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Horómetro final")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_final
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "columna", colspan: "2" } })
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Operación")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_operacion
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [_vm._v("Marcha")]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_marcha
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Marcha con Crucero")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_marcha_crucero
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Ralentí")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_ralenti
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v("Detenido no Ralentí")
                        ]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_detenido_no_ralenti
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("th", { attrs: { id: "data" } }, [_vm._v("PTO")]),
                        _c("th", { attrs: { id: "data" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatFloat(
                                  _vm.data.reporte_conduccion[0].tiempo
                                    .horometro_pto
                                )
                              ) +
                              "\n              Hr\n            "
                          )
                        ])
                      ])
                    ]),
                    _c("doughnutComp", {
                      ref: "doughnutCompRefTiempo",
                      attrs: { height: 280 }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "fieldset",
              {
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  display: "flex",
                  height: "95%",
                  border: "1px solid rgb(220, 220, 220)"
                }
              },
              [
                _c(
                  "legend",
                  {
                    staticStyle: {
                      "margin-left": "0.3rem",
                      color: "#9e9e9e",
                      "font-size": "0.8rem"
                    }
                  },
                  [_vm._v("\n        Consumo de combustible\n      ")]
                ),
                _c(
                  "v-card",
                  { staticClass: "cards2" },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c("barComp", {
                          ref: "barFuelComp",
                          attrs: { height: 280 }
                        })
                      ],
                      1
                    ),
                    _c("v-divider", {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px"
                      }
                    }),
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c(
                          "v-card",
                          [
                            _c("AgGridVue", {
                              staticClass: "ag-theme-material",
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { gridOptions: _vm.gridOptionBar }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-card",
                  { staticClass: "cards2" },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c("lineComp", {
                          ref: "lineFuelComp",
                          attrs: { height: 280 }
                        })
                      ],
                      1
                    ),
                    _c("v-divider", {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px"
                      }
                    }),
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c(
                          "v-card",
                          [
                            _c("AgGridVue", {
                              staticClass: "ag-theme-material",
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { gridOptions: _vm.gridOptionLine }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }